/**
 * @license
 *
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @fileoverview Define custom blocks.
 * @author samelh@google.com (Sam El-Husseini)
 */
// More on defining blocks:
// https://developers.google.com/blockly/guides/create-custom-blocks/define-blocks
import * as Blockly from 'blockly/core';
var turnField = {
  type: 'turn',
  message0: 'turn %1 degrees',
  args0: [{
    type: 'field_number',
    name: 'NUM'
  }],
  previousStatement: null,
  nextStatement: null
};
Blockly.Blocks['turn'] = {
  init: function init() {
    this.jsonInit(turnField);
    this.setStyle('robot');
  }
};
var driveField = {
  type: 'drive',
  message0: 'drive',
  previousStatement: null,
  nextStatement: null
};
Blockly.Blocks['drive'] = {
  init: function init() {
    this.jsonInit(driveField);
    this.setStyle('robot');
  }
};
var driveStopField = {
  type: 'driveStop',
  message0: 'driveStop',
  previousStatement: null,
  nextStatement: null
};
Blockly.Blocks['driveStop'] = {
  init: function init() {
    this.jsonInit(driveStopField);
    this.setStyle('robot');
  }
};
var touchSensorField = {
  type: 'touchSensor',
  message0: 'touchSensor is %1',
  args0: [{
    type: 'field_dropdown',
    name: 'STATE',
    options: [['pressed', '1'], ['not pressed', '0']]
  }],
  output: 'Boolean'
};
Blockly.Blocks['touchSensor'] = {
  init: function init() {
    this.jsonInit(touchSensorField);
    this.setStyle('robot');
  }
};
var waitUntilField = {
  type: 'logic_waitUntil',
  message0: 'waitUntil %1',
  args0: [{
    type: 'input_value',
    name: 'CONDITION'
  }],
  previousStatement: null,
  nextStatement: null
};
Blockly.Blocks['logic_waitUntil'] = {
  init: function init() {
    this.jsonInit(waitUntilField);
    this.setStyle('logic_blocks');
  }
};
var waitForSeconds = {
  type: 'logic_waitForSeconds',
  message0: 'Wait for %1 seconds',
  args0: [{
    type: 'field_number',
    name: 'NUM'
  }],
  previousStatement: null,
  nextStatement: null
};
Blockly.Blocks['logic_waitForSeconds'] = {
  init: function init() {
    this.jsonInit(waitForSeconds);
    this.setStyle('robot');
  }
};
var shootTorpedo = {
  type: 'shootTorpedo',
  message0: 'Shoot Torpedo',
  previousStatement: null,
  nextStatement: null
};
Blockly.Blocks['shootTorpedo'] = {
  init: function init() {
    this.jsonInit(shootTorpedo);
    this.setStyle('robot');
  }
};